import React, { useState } from 'react';
import { Container, Box } from '@mui/material';
import TabsComponent from '../../../../../components/NewTabs';
import OpenVpnConfig from './OpenVpnConfig';
import './VpnTab.css';

interface Props {
  selectedRow?: any;
  refreshIconClicked?: any;
  notifyConfigAction?: () => void;
  notifyConfigActionComplete?: () => void;
}

/**
 * VPN configuration tab. Currently exposes a single "OpenVPN" sub-tab.
 * Uses the same sub-tab pattern (TabsComponent) as the Interfaces tab.
 */
const VpnTab: React.FC<Props> = ({ selectedRow, refreshIconClicked, notifyConfigAction, notifyConfigActionComplete }) => {
  const [activeTab, setActiveTab] = useState('openvpn');

  const tabs = [{ tabName: 'OpenVPN', tabValue: 'openvpn', pathName: '/inventory' }];

  const doNavigateTab = (_pathname: string, tabName: string) => {
    setActiveTab(tabName);
  };

  return (
    <div className="internalPadding">
      <TabsComponent
        tabs={tabs}
        handleChangeTab={doNavigateTab}
        activeTab={activeTab}
        isSubTabs={true}
        removemarginTop={true}
      />
      <Container maxWidth="xl" className="app-container">
        {activeTab === 'openvpn' && (
          <Box my={0}>
            <OpenVpnConfig selectedRow={selectedRow} refreshIconClicked={refreshIconClicked} notifyConfigAction={notifyConfigAction} notifyConfigActionComplete={notifyConfigActionComplete} />
          </Box>
        )}
      </Container>
    </div>
  );
};

export default VpnTab;
